import React from 'react'
import { Link } from 'react-router-dom';
import Slider from 'react-slick';

function EventSlider() {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    centerPadding: '10%',
                    centerMode: true,
                },
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    centerPadding: '10%',
                    centerMode: true,
                },
            },
        ],
    };



    return (
        <>
            <Slider {...settings}>
                {[1, 2, 3, 4, 5, 6].map((_, i) => (
                    <div key={i} className="px-[14px]">
                        <img src="/assets/home/img2.png" className='w-full' alt="" />
                        <div className='pt-[25px]'>
                        <div className='flex justify-between items-center '>
                            <div className="flex items-center gap-[10px] ">
                                <img src="/assets/home/calender.svg" alt="" />
                                <p className="font-[400] font-inter text-[16px] leading-[28px] text-[#110C2D]">August 20, 2024</p>
                            </div>
                            <p className="font-[800] font-manrope text-[16px] text-[#FF6000]">BHAKTI MANDIR</p>
                        </div>
                        <p className="font-[700] font-manrope text-[21px] leading-[34px] text-[#262626] py-[14px]">Yoga Relaxtation and meditation</p>
                        <Link to="">
                            <img src="/assets/home/arrow-btn.svg" alt="" />
                        </Link>
                        </div>
                    </div>
                ))}
            </Slider>
        </>
    )
}

export default EventSlider